import ChatView from '../components/chat/ChatView';

export function ChatPage() {
  return <ChatView />;
}

export default ChatPage;
